export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-200/80 bg-slate-50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-10 md:grid-cols-3 md:gap-10 md:px-6">
        <div>
          <a
            href="#home"
            className="inline-flex items-center text-lg font-bold tracking-tight text-slate-900 transition hover:text-accent-hover"
          >
            GestAlt
          </a>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-600">
            Unified hospital information systems built for clinical, operational,
            and financial excellence.
          </p>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
            Quick links
          </p>
          <div className="mt-4 flex flex-wrap gap-3 text-sm">
            <a className="text-slate-700 transition hover:text-accent-hover" href="#product">
              Product
            </a>
            <a className="text-slate-700 transition hover:text-accent-hover" href="#solutions">
              The Challenge
            </a>
            <a className="text-slate-700 transition hover:text-accent-hover" href="#how-it-works">
              How it works
            </a>
            <a className="text-slate-700 transition hover:text-accent-hover" href="#use-cases">
              Use cases
            </a>
            <a className="text-slate-700 transition hover:text-accent-hover" href="#resources">
              Social proof
            </a>
            <a className="text-slate-700 transition hover:text-accent-hover" href="#security">
              Security
            </a>
            <a className="text-slate-700 transition hover:text-accent-hover" href="#company">
              About
            </a>
            <a className="text-slate-700 transition hover:text-accent-hover" href="#demo-form">
              Request a demo
            </a>
          </div>
        </div>

        <div className="md:text-right">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
            Contact
          </p>
          <a
            href="mailto:hello@gestalt.health"
            className="mt-4 inline-block text-sm font-semibold text-slate-700 transition hover:text-accent-hover"
          >
            hello@gestalt.health
          </a>
          <p className="mt-2 text-sm text-slate-600">Enterprise support available 24/7</p>
        </div>
      </div>

      <div className="border-t border-slate-200/80 px-4 py-4 md:px-6">
        <p className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 text-xs text-slate-500 md:flex-row">
          <span>© {year} GestAlt. All rights reserved.</span>
          <span>Privacy and compliance-first by design.</span>
        </p>
      </div>
    </footer>
  );
}
